(function () {
  'use strict';
  var STORE = 'sc-gate:';

  function isUnlocked(id) {
    try { return localStorage.getItem(STORE + id) === '1'; } catch (e) { return false; }
  }

  function remember(id) {
    try { localStorage.setItem(STORE + id, '1'); } catch (e) {}
  }

  function show(dlg, which) {
    var form = dlg.querySelector('[data-sc-gate-form]');
    var done = dlg.querySelector('[data-sc-gate-done]');
    if (form) form.hidden = which !== 'form';
    if (done) done.hidden = which !== 'done';
  }

  function sync(dlg) {
    show(dlg, isUnlocked(dlg.getAttribute('data-sc-gate')) ? 'done' : 'form');
  }

  function open(dlg) {
    sync(dlg);
    if (!dlg.open) {
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    }
    if (!isUnlocked(dlg.getAttribute('data-sc-gate'))) {
      var input = dlg.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus(); }, 60);
    }
  }

  function unlock(dlg) {
    remember(dlg.getAttribute('data-sc-gate'));
    show(dlg, 'done');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-sc-gate-open]');
    if (opener) {
      var dlg = document.getElementById('sc-gate-' + opener.getAttribute('data-sc-gate-open'));
      if (dlg) { e.preventDefault(); open(dlg); }
      return;
    }

    var closer = t.closest('[data-sc-gate-close]');
    if (closer) {
      var owner = closer.closest('dialog');
      if (owner) { e.preventDefault(); owner.close(); }
      return;
    }

    if (t.tagName === 'DIALOG' && t.hasAttribute('data-sc-gate')) t.close();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-sc-gate-post')) return;
    var dlg = form.closest('dialog');
    if (!dlg) return;

    var input = form.querySelector('input[type="email"]');
    if (input && typeof input.checkValidity === 'function' && !input.checkValidity()) {
      e.preventDefault();
      if (input.reportValidity) input.reportValidity();
      return;
    }

    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }

    var done = function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
      unlock(dlg);
    };

    if (typeof fetch !== 'function') { form.submit(); return; }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'text/html' }
    }).then(done, done);
  });

  function init() {
    var list = document.querySelectorAll('[data-sc-gate]');
    for (var i = 0; i < list.length; i++) sync(list[i]);

    var m = window.location.search.match(/[?&]sc_unlock=([^&]+)/);
    if (!m) return;
    var target = document.getElementById('sc-gate-' + decodeURIComponent(m[1]));
    if (target) { unlock(target); open(target); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
